/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Hide_FiltersInputs */

const cs_calendar_hide_filters = /** @type {(inputs: Calendar_Hide_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt filtry`)
};

const en_calendar_hide_filters = /** @type {(inputs: Calendar_Hide_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide filters`)
};

/**
* | output |
* | --- |
* | "Hide filters" |
*
* @param {Calendar_Hide_FiltersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_hide_filters = /** @type {((inputs?: Calendar_Hide_FiltersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Hide_FiltersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_hide_filters(inputs)
	return cs_calendar_hide_filters(inputs)
});